var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinciples3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_19504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint0_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint1_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint2_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint3_radial_715_19504)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint4_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint5_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint6_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 52.4961C44.3333 52.4961 52.4961 41.5279 52.4961 27.998C52.4961 14.4681 44.3333 3.5 27.998 3.5C11.6628 3.5 3.5 14.4681 3.5 27.998C3.5 41.5279 11.6628 52.4961 27.998 52.4961Z",
    fill: "url(#paint7_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 35C40.25 41.7725 34.7725 47.25 28 47.25C21.2275 47.25 15.75 41.7725 15.75 35H28H40.25Z",
    fill: "url(#paint8_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 35H33.25V36.625C33.25 37.1773 32.8023 37.625 32.25 37.625H23.75C23.1977 37.625 22.75 37.1773 22.75 36.625V35Z",
    fill: "url(#paint9_linear_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 31.5C20.9742 31.5 24.5 27.9742 24.5 23.625C24.5 19.2758 20.9742 15.75 16.625 15.75C12.2758 15.75 8.75 19.2758 8.75 23.625C8.75 27.9742 12.2758 31.5 16.625 31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375 31.5C43.7242 31.5 47.25 27.9742 47.25 23.625C47.25 19.2758 43.7242 15.75 39.375 15.75C35.0258 15.75 31.5 19.2758 31.5 23.625C31.5 27.9742 35.0258 31.5 39.375 31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 19.25C15.9582 19.25 14 21.2082 14 23.625C14 26.0418 15.9582 28 18.375 28C20.7918 28 22.75 26.0418 22.75 23.625C22.75 21.2082 20.7918 19.25 18.375 19.25ZM37.625 19.25C35.2082 19.25 33.25 21.2082 33.25 23.625C33.25 26.0418 35.2082 28 37.625 28C40.0418 28 42 26.0418 42 23.625C42 21.2082 40.0418 19.25 37.625 19.25Z",
    fill: "#402A32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 22.75C1.75 21.7835 2.5335 21 3.5 21H7.875V24.5H3.5C2.5335 24.5 1.75 23.7165 1.75 22.75ZM52.3478 24.5H48.125V21H52.3478C53.394 21 54.25 21.7875 54.25 22.75C54.25 23.7125 53.394 24.5 52.3478 24.5ZM24.5 21H31.5V24.5H24.5V21Z",
    fill: "url(#paint10_linear_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 15.75C12.2758 15.75 8.75 19.2758 8.75 23.625C8.75 27.9742 12.2758 31.5 16.625 31.5C20.9742 31.5 24.5 27.9742 24.5 23.625C24.5 19.2758 20.9742 15.75 16.625 15.75ZM7 23.625C7 18.3093 11.3093 14 16.625 14C21.9407 14 26.25 18.3093 26.25 23.625C26.25 28.9407 21.9407 33.25 16.625 33.25C11.3093 33.25 7 28.9407 7 23.625Z",
    fill: "url(#paint11_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.375 15.7628C35.0328 15.7628 31.5128 19.2828 31.5128 23.625C31.5128 27.9672 35.0328 31.4872 39.375 31.4872C43.7172 31.4872 47.2372 27.9672 47.2372 23.625C47.2372 19.2828 43.7172 15.7628 39.375 15.7628ZM29.75 23.625C29.75 18.3093 34.0593 14 39.375 14C44.6907 14 49 18.3093 49 23.625C49 28.9407 44.6907 33.25 39.375 33.25C34.0593 33.25 29.75 28.9407 29.75 23.625Z",
    fill: "url(#paint12_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 15.75C12.2758 15.75 8.75 19.2758 8.75 23.625C8.75 27.9742 12.2758 31.5 16.625 31.5C20.9742 31.5 24.5 27.9742 24.5 23.625C24.5 19.2758 20.9742 15.75 16.625 15.75ZM7 23.625C7 18.3093 11.3093 14 16.625 14C21.9407 14 26.25 18.3093 26.25 23.625C26.25 28.9407 21.9407 33.25 16.625 33.25C11.3093 33.25 7 28.9407 7 23.625Z",
    fill: "url(#paint13_radial_715_19504)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.375 15.75C35.0258 15.75 31.5 19.2758 31.5 23.625C31.5 27.9742 35.0258 31.5 39.375 31.5C43.7242 31.5 47.25 27.9742 47.25 23.625C47.25 19.2758 43.7242 15.75 39.375 15.75ZM29.75 23.625C29.75 18.3093 34.0593 14 39.375 14C44.6907 14 49 18.3093 49 23.625C49 28.9407 44.6907 33.25 39.375 33.25C34.0593 33.25 29.75 28.9407 29.75 23.625Z",
    fill: "url(#paint14_radial_715_19504)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.625 15.75) rotate(132.839) scale(65.6308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.625 15.75) rotate(131.878) scale(68.1602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 21.875) rotate(101.31) scale(31.2315 40.0016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5 24.5) rotate(135) scale(71.7713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 29.75) rotate(77.692) scale(49.2571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.875 28.875) rotate(55.7131) scale(23.2987 16.8881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.875 31.5) rotate(9.86581) scale(20.4271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.625 26.25) rotate(43.9708) scale(103.343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 49.9722) rotate(-90) scale(16.7222 33.4444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_19504",
    x1: 28,
    y1: 35,
    x2: 28,
    y2: 37.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEA4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279919,
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_19504",
    x1: 28,
    y1: 21,
    x2: 28,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2C4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.75 19.25) rotate(131.186) scale(18.6028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54424A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52394D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5 19.25) rotate(131.186) scale(18.6028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54424A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52394D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 23.625) rotate(170.538) scale(10.6448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.899365,
    stopColor: "#3B2131",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422833"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_19504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.25 23.625) rotate(170.538) scale(10.6448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.899365,
    stopColor: "#3B2131",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422833"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_19504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciples3);
export default __webpack_public_path__ + "static/media/principles3.da878b8f2609c0008de0fda6ab870122.svg";
export { ForwardRef as ReactComponent };